<!-- Full-page marble background -->
<div class="min-h-screen flex flex-col"
	style="background-image: url('/images/marble_texture.png'); background-size: cover; background-position: center;">

	<!-- Marble border top -->
	<img src="/images/marbleBorder.png" alt="" style="width: 100%; height: 20px; display: block; object-fit: cover; flex-shrink:0;" />

	<!-- Content -->
	<div class="flex flex-1 items-start justify-center px-8 py-10">
		<div class="w-full" style="max-width: 780px;">

			<!-- Brand header -->
			<div class="mb-8 text-center">
				<h1 style="font-family: var(--font-family-display); font-size: 1.5rem; font-weight: 600; letter-spacing: 0.12em; color: var(--color-aegean-700);">
					<span ro-i18n eikey="login.brandName">The Socrates Initiative</span>
				</h1>
				<div style="width: 60px; border-top: 1px solid var(--color-gold-500); margin: 8px auto;"></div>
				<p style="font-family: var(--font-family-display); font-size: 0.6rem; letter-spacing: 0.18em; text-transform: uppercase; color: var(--color-gold-600);">
					<span ro-i18n eikey="login.brandTagline">Constructive Planning for Results</span>
				</p>
			</div>

			<!-- Card -->
			<div class="rounded-lg shadow-2xl overflow-hidden"
				style="border: 6px solid var(--color-sandstone); outline: 1px solid var(--color-gold-500);">

				<!-- Card top border -->
				<img src="/images/marbleBorder.png" alt="" style="width: 100%; height: 20px; display: block; object-fit: cover;" />

				<div style="background-image: url('/images/marble_texture.png'); background-size: cover; padding: 40px 50px 32px;">

					<h2 class="mb-6 text-2xl font-semibold" style="color: var(--color-charcoal); font-family: var(--font-family-display); letter-spacing: 0.03em;">
						<span ro-i18n eikey="signup.heading">Create Account</span>
					</h2>

					@if (orgsLoading()) {
						<div class="flex items-center gap-2 mb-4" style="color: var(--color-aegean-700);">
							<svg class="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24">
								<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
								<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
							</svg>
							<span class="text-sm" ro-i18n eikey="general.loading">Loading…</span>
						</div>
					}

					@if (successMsg()) {
						<div class="mb-6 rounded border px-4 py-3 text-sm"
							style="border-color: var(--color-aegean-400); background-color: rgba(70,120,160,0.08); color: var(--color-aegean-700);">
							{{ successMsg() }}
						</div>
					}

					@if (submitError()) {
						<div class="mb-4 rounded border px-4 py-3 text-sm"
							style="border-color: var(--color-terra-500); background-color: rgba(195,90,60,0.08); color: var(--color-terra-600);">
							{{ submitError() }}
						</div>
					}

					@if (inviteError()) {
					<div class="mb-4 rounded border px-4 py-3 text-sm"
						style="border-color: var(--color-terra-500); background-color: rgba(195,90,60,0.08); color: var(--color-terra-600);">
						{{ inviteError() }}
					</div>
				}

				@if (inviteOrgName()) {
					<div class="mb-4 rounded border px-4 py-3 text-sm"
						style="border-color: var(--color-aegean-400); background-color: rgba(70,120,160,0.08); color: var(--color-aegean-700);">
						<span ro-i18n eikey="signup.invite.notice">You've been invited to join</span>&nbsp;<strong>{{ inviteOrgName() }}</strong>.
					</div>
				}

				@if (!successMsg()) {
						<form [formGroup]="signupForm" (ngSubmit)="onSubmit()" novalidate>

							<!-- ── Section: Identity ── -->
							<div class="mb-6">
								<h3 class="text-xs font-semibold uppercase tracking-widest mb-4" style="color: var(--color-gold-600); font-family: var(--font-family-display);">
									<span ro-i18n eikey="signup.section.identity">Your Information</span>
								</h3>

								<!-- Org selector — hidden when a valid invite pre-selects the org -->
								@if (showOrgSelector && !inviteOrgName()) {
									<div class="mb-4">
										<label class="mb-1 block text-xs font-medium tracking-wide" style="color: var(--color-charcoal); font-family: var(--font-family-ui);">
											<span ro-i18n eikey="signup.field.org">Organization</span>
										</label>
										<select
											formControlName="orgId"
											class="w-full rounded border px-3 py-2 text-sm outline-none"
											style="border-color: var(--color-sandstone); background-color: var(--color-marble); color: var(--color-charcoal); font-family: var(--font-family-ui);">
											<option value="" disabled>{{ getMessage('signup.field.orgPlaceholder') }}</option>
											@for (org of orgs; track org.id) {
												<option [value]="org.id">{{ org.name }}</option>
											}
										</select>
									</div>
								}

								<!-- First / Last -->
								<div class="flex gap-4 mb-4">
									<div class="flex-1">
										<label class="mb-1 block text-xs font-medium tracking-wide" style="color: var(--color-charcoal); font-family: var(--font-family-ui);">
											<span ro-i18n eikey="signup.field.firstName">First Name</span>
										</label>
										<input formControlName="firstName" type="text"
											class="w-full rounded border px-3 py-2 text-sm outline-none"
											style="border-color: var(--color-sandstone); background-color: var(--color-marble); color: var(--color-charcoal);"
											[placeholder]="getMessage('signup.field.firstName')" />
									</div>
									<div class="flex-1">
										<label class="mb-1 block text-xs font-medium tracking-wide" style="color: var(--color-charcoal); font-family: var(--font-family-ui);">
											<span ro-i18n eikey="signup.field.lastName">Last Name</span>
										</label>
										<input formControlName="lastName" type="text"
											class="w-full rounded border px-3 py-2 text-sm outline-none"
											style="border-color: var(--color-sandstone); background-color: var(--color-marble); color: var(--color-charcoal);"
											[placeholder]="getMessage('signup.field.lastName')" />
									</div>
								</div>

								<!-- Email -->
								<div class="mb-4">
									<label class="mb-1 block text-xs font-medium tracking-wide" style="color: var(--color-charcoal); font-family: var(--font-family-ui);">
										<span ro-i18n eikey="general.email">Email</span>
									</label>
									<input formControlName="email" type="email" autocomplete="email"
										class="w-full rounded border px-3 py-2 text-sm outline-none"
										style="border-color: var(--color-sandstone); background-color: var(--color-marble); color: var(--color-charcoal);"
										[class.border-red-400]="submitAttempted() && signupForm.get('email').invalid"
										[placeholder]="getMessage('general.email')" />
									@if (submitAttempted() && signupForm.get('email').hasError('required')) {
										<p class="mt-1 text-xs" style="color: var(--color-terra-600);">
											<span ro-i18n eikey="signup.error.emailRequired">Email is required.</span>
										</p>
									}
									@if (submitAttempted() && signupForm.get('email').hasError('email')) {
										<p class="mt-1 text-xs" style="color: var(--color-terra-600);">
											<span ro-i18n eikey="signup.error.emailInvalid">Please enter a valid email address.</span>
										</p>
									}
								</div>

								<!-- Password / Confirm -->
								<div class="flex gap-4">
									<div class="flex-1">
										<label class="mb-1 block text-xs font-medium tracking-wide" style="color: var(--color-charcoal); font-family: var(--font-family-ui);">
											<span ro-i18n eikey="general.password">Password</span>
										</label>
										<input formControlName="password" type="password" autocomplete="new-password"
											class="w-full rounded border px-3 py-2 text-sm outline-none"
											style="border-color: var(--color-sandstone); background-color: var(--color-marble); color: var(--color-charcoal);"
											[placeholder]="getMessage('general.password')" />
										@if (submitAttempted() && signupForm.get('password').hasError('passwordStrength')) {
											<p class="mt-1 text-xs" style="color: var(--color-terra-600);">
												<span ro-i18n eikey="signup.error.passwordStrength">Min 8 characters with uppercase, lowercase, and a digit.</span>
											</p>
										}
									</div>
									<div class="flex-1">
										<label class="mb-1 block text-xs font-medium tracking-wide" style="color: var(--color-charcoal); font-family: var(--font-family-ui);">
											<span ro-i18n eikey="signup.field.confirmPassword">Confirm Password</span>
										</label>
										<input formControlName="confirmPassword" type="password" autocomplete="new-password"
											class="w-full rounded border px-3 py-2 text-sm outline-none"
											style="border-color: var(--color-sandstone); background-color: var(--color-marble); color: var(--color-charcoal);"
											[placeholder]="getMessage('signup.field.confirmPassword')" />
										@if (submitAttempted() && signupForm.hasError('passwordMismatch')) {
											<p class="mt-1 text-xs" style="color: var(--color-terra-600);">
												<span ro-i18n eikey="signup.error.passwordMismatch">Passwords do not match.</span>
											</p>
										}
									</div>
								</div>
							</div>

							<!-- ── Section: Payment (conditional) ── -->
							@if (showPaymentField) {
								<div class="mb-6">
									<h3 class="text-xs font-semibold uppercase tracking-widest mb-4" style="color: var(--color-gold-600); font-family: var(--font-family-display);">
										<span ro-i18n eikey="signup.section.payment">Payment</span>
									</h3>

									<div class="rounded border" style="border-color: var(--color-gold-500); background-color: rgba(180,138,74,0.06); padding: 28px;">

										<div class="flex items-center justify-between mb-3">
											<span class="text-sm font-medium" style="color: var(--color-charcoal); font-family: var(--font-family-ui);">
												<span ro-i18n eikey="signup.billing.notice">Membership fee:</span>
												<strong class="ml-1">{{ chargeLabel }}</strong>
											</span>
										</div>

										@if (selectedOrg?.joinMode === 'REVIEW') {
											<div class="rounded mb-4 px-3 py-2 text-xs leading-relaxed" style="background-color: rgba(70,120,160,0.08); border: 1px solid var(--color-aegean-300); color: var(--color-aegean-700); font-family: var(--font-family-ui);">
												<span ro-i18n eikey="signup.billing.reviewNotice">Your membership request will be reviewed by an administrator before your account is activated. <strong>Your card will not be charged unless your application is approved.</strong></span>
											</div>
										}

										@if (bypassPayment) {
										<div class="rounded px-3 py-2 text-xs leading-relaxed" style="background-color: rgba(234,179,8,0.1); border: 1px dashed var(--color-gold-500); color: var(--color-charcoal); font-family: var(--font-family-ui);">
											<strong>Dev / Stage:</strong> Payment collection is bypassed. No card will be charged.
										</div>
									} @else {
										<!-- Name on card -->
										<div class="mb-4">
											<label class="mb-1 block text-xs font-medium tracking-wide" style="color: var(--color-charcoal); font-family: var(--font-family-ui);">
												<span ro-i18n eikey="signup.billing.cardholderName">Name on Card</span>
											</label>
											<input formControlName="billingName" type="text" autocomplete="cc-name"
												class="w-full rounded border px-3 py-2 text-sm outline-none"
												style="border-color: var(--color-sandstone); background-color: var(--color-marble); color: var(--color-charcoal);"
												[placeholder]="getMessage('signup.billing.cardholderNamePlaceholder')" />
										</div>

										<!-- Card number -->
										<div class="mb-4">
											<label class="mb-1 block text-xs font-medium tracking-wide" style="color: var(--color-charcoal); font-family: var(--font-family-ui);">
												<span ro-i18n eikey="signup.billing.cardNumber">Card Number</span>
											</label>
											<div #cardNumberEl class="rounded border px-3 py-2.5" style="border-color: var(--color-sandstone); background-color: var(--color-marble); min-height: 40px;"></div>
										</div>

										<!-- Expiry + CVC + ZIP -->
										<div class="flex gap-4 mb-4">
											<div class="flex-1">
												<label class="mb-1 block text-xs font-medium tracking-wide" style="color: var(--color-charcoal); font-family: var(--font-family-ui);">
													<span ro-i18n eikey="signup.billing.expiry">Expiry Date</span>
												</label>
												<div #cardExpiryEl class="rounded border px-3 py-2.5" style="border-color: var(--color-sandstone); background-color: var(--color-marble); min-height: 40px;"></div>
											</div>
											<div class="flex-1">
												<label class="mb-1 block text-xs font-medium tracking-wide" style="color: var(--color-charcoal); font-family: var(--font-family-ui);">
													<span ro-i18n eikey="signup.billing.cvc">Security Code (CVV)</span>
												</label>
												<div #cardCvcEl class="rounded border px-3 py-2.5" style="border-color: var(--color-sandstone); background-color: var(--color-marble); min-height: 40px;"></div>
											</div>
											<div style="width: 130px;">
												<label class="mb-1 block text-xs font-medium tracking-wide" style="color: var(--color-charcoal); font-family: var(--font-family-ui);">
													<span ro-i18n eikey="signup.billing.billingZip">Billing ZIP</span>
												</label>
												<input formControlName="billingZip" type="text" maxlength="10" autocomplete="postal-code"
													class="w-full rounded border px-3 py-2 text-sm outline-none"
													style="border-color: var(--color-sandstone); background-color: var(--color-marble); color: var(--color-charcoal);"
													[placeholder]="getMessage('signup.billing.billingZipPlaceholder')" />
											</div>
										</div>

										@if (stripeError()) {
											<p class="mb-2 text-xs" style="color: var(--color-terra-600);">{{ stripeError() }}</p>
										}
										<p class="text-xs opacity-60" style="color: var(--color-charcoal); font-family: var(--font-family-ui);">
											<span ro-i18n eikey="signup.billing.secureNotice">Payments are processed securely by Stripe. We never store your card details.</span>
										</p>
									}
									</div>
								</div>
							}

							<!-- ── Section: Preferences ── -->
						<div class="mb-6">
							<h3 class="text-xs font-semibold uppercase tracking-widest mb-4" style="color: var(--color-gold-600); font-family: var(--font-family-display);">
								<span ro-i18n eikey="signup.section.preferences">Preferences</span>
							</h3>

							<!-- Timezone -->
							<div class="mb-4">
								<label class="mb-1 block text-xs font-medium tracking-wide" style="color: var(--color-charcoal); font-family: var(--font-family-ui);">
									<span ro-i18n eikey="signup.prefs.timezone">Timezone</span>
								</label>
								<select formControlName="timezone"
									class="w-full rounded border px-3 py-2 text-sm outline-none"
									style="border-color: var(--color-sandstone); background-color: var(--color-marble); color: var(--color-charcoal); font-family: var(--font-family-ui);">
									@for (tz of timezones; track tz) {
										<option [value]="tz">{{ tz }}</option>
									}
								</select>
							</div>

							<!-- Notification preferences -->
							<p class="mb-2 text-xs font-medium tracking-wide" style="color: var(--color-charcoal); font-family: var(--font-family-ui);">
								<span ro-i18n eikey="signup.prefs.notificationsLabel">Email me when:</span>
							</p>
							<div class="flex flex-col gap-2">
								<label class="flex items-center gap-3 cursor-pointer">
									<input type="checkbox" formControlName="notifyFloorEvents"
										class="h-4 w-4 rounded flex-shrink-0"
										style="accent-color: var(--color-aegean-700);" />
									<span class="text-xs leading-relaxed" style="color: var(--color-charcoal); font-family: var(--font-family-ui);">
										<span ro-i18n eikey="signup.prefs.notifyFloorEvents">An idea I'm following moves to or off the Floor</span>
									</span>
								</label>
								<label class="flex items-center gap-3 cursor-pointer">
									<input type="checkbox" formControlName="notifyObjections"
										class="h-4 w-4 rounded flex-shrink-0"
										style="accent-color: var(--color-aegean-700);" />
									<span class="text-xs leading-relaxed" style="color: var(--color-charcoal); font-family: var(--font-family-ui);">
										<span ro-i18n eikey="signup.prefs.notifyObjections">An objection is raised or resolved on a contribution I'm involved with</span>
									</span>
								</label>
								<label class="flex items-center gap-3 cursor-pointer">
									<input type="checkbox" formControlName="notifyDecisions"
										class="h-4 w-4 rounded flex-shrink-0"
										style="accent-color: var(--color-aegean-700);" />
									<span class="text-xs leading-relaxed" style="color: var(--color-charcoal); font-family: var(--font-family-ui);">
										<span ro-i18n eikey="signup.prefs.notifyDecisions">A membership decision is made on my application</span>
									</span>
								</label>
							</div>
						</div>

						<!-- ── Section: Terms of Service ── -->
						<div class="mb-6">
							<h3 class="text-xs font-semibold uppercase tracking-widest mb-3" style="color: var(--color-gold-600); font-family: var(--font-family-display);">
								<span ro-i18n eikey="signup.section.terms">Terms &amp; Agreement</span>
							</h3>
							<div class="rounded border px-4 py-3 mb-3 text-xs leading-relaxed"
								style="border-color: var(--color-sandstone); background-color: rgba(233,225,211,0.4); color: var(--color-charcoal); font-family: var(--font-family-ui); max-height: 120px; overflow-y: auto;">
								<strong>{{ getMessage('legal.tos.s1.heading') }}</strong>
								{{ getMessage('legal.tos.s1.body') }}
							</div>
							<label class="flex items-start gap-3 cursor-pointer">
								<input type="checkbox" formControlName="tosAccepted"
									class="mt-0.5 h-4 w-4 rounded flex-shrink-0"
									style="accent-color: var(--color-aegean-700);" />
								<span class="text-xs leading-relaxed" style="color: var(--color-charcoal); font-family: var(--font-family-ui);">
									<span ro-i18n eikey="signup.tos.checkboxLabel">I have read and agree to the</span>
									<a href="/tos" target="_blank" rel="noopener" class="underline" style="color: var(--color-aegean-600); margin-left: 4px; margin-right: 4px;">
										<span ro-i18n eikey="signup.tos.linkText">Terms of Service</span>
									</a>
									<span ro-i18n eikey="signup.tos.and">and</span>
									<a href="/community-guidelines" target="_blank" rel="noopener" class="underline" style="color: var(--color-aegean-600); margin-left: 4px;">
										<span ro-i18n eikey="signup.tos.guidelinesLinkText">Community Guidelines</span>
									</a>.
								</span>
							</label>
							@if (submitAttempted() && signupForm.get('tosAccepted').hasError('requiredTrue')) {
								<p class="mt-1 text-xs" style="color: var(--color-terra-600);">
									<span ro-i18n eikey="signup.tos.required">You must accept the terms to continue.</span>
								</p>
							}
						</div>

						<!-- Review notice (non-payment orgs) -->
							@if (selectedOrg?.joinMode === 'REVIEW' && !showPaymentField) {
								<div class="mb-6 rounded px-3 py-2 text-xs leading-relaxed" style="background-color: rgba(70,120,160,0.08); border: 1px solid var(--color-aegean-300); color: var(--color-aegean-700); font-family: var(--font-family-ui);">
									<span ro-i18n eikey="signup.reviewNotice">Your membership request will be reviewed by an administrator before your account is activated. You will be notified by email once a decision has been made.</span>
								</div>
							}

							<!-- ── Submit ── -->
							<div style="border-top: 1px solid var(--color-sandstone); padding-top: 20px;">
								<div class="flex items-center justify-between">
									<button type="button" (click)="onCancel()"
										class="text-xs transition-colors"
										style="color: var(--color-aegean-600); font-family: var(--font-family-ui);">
										<span ro-i18n eikey="signup.backToLogin">Already have an account? Sign in</span>
									</button>
									<button
										type="submit"
										[disabled]="submitting() || orgsLoading()"
										class="rounded px-6 py-2.5 text-sm font-semibold tracking-wide shadow transition-colors disabled:cursor-not-allowed disabled:opacity-50"
										style="background-color: var(--color-aegean-600); color: var(--color-marble); font-family: var(--font-family-display); letter-spacing: 0.06em;">
										@if (submitting()) {
											<span class="flex items-center gap-2">
												<svg class="h-4 w-4 animate-spin" fill="none" viewBox="0 0 24 24">
													<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
													<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
												</svg>
												<span ro-i18n eikey="general.loading">Signing up…</span>
											</span>
										} @else {
											<span ro-i18n eikey="signup.submit">Join the Forum</span>
										}
									</button>
								</div>
							</div>

						</form>
					}

				</div>

				<!-- Card bottom border -->
				<img src="/images/marbleBorder.png" alt="" style="width: 100%; height: 20px; display: block; object-fit: cover;" />

			</div>

		</div>
	</div>

	<!-- Marble border bottom -->
	<img src="/images/marbleBorder.png" alt="" style="width: 100%; height: 20px; display: block; object-fit: cover; flex-shrink:0;" />

</div>
